import Harrison from '../../pages/harrison/Harrison'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.HARRISON, component: Harrison },
])
